<template>
  <div>
    <v-row no-gutters align="center" class="content-header">
      <v-btn class="n-white-btn n-small-btn px-2" to="/interventions">
        <v-icon small class="mr-2">chevron_left</v-icon>
        Retour interventions
      </v-btn>
      <v-col>
        <span class="font-weight-bold ml-4">{{ title }}</span>
      </v-col>
    </v-row>
    <choose-client v-if="currentStep === `chooseClient`" @ready="subComponentReady = true" @choose="clientChoosen" />
    <choose-site v-if="currentStep === `chooseSite`" @ready="subComponentReady = true" @choose="siteChoosen" />
    <choose-makers v-if="currentStep === `chooseMakers`" @ready="subComponentReady = true" @choose="makersChoosen" />
    <ticket-details v-if="currentStep === `ticketDetails`" @ready="subComponentReady = true" @cancel="restart()" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ChooseClient from "./ChooseClient.vue";
import ChooseSite from "./ChooseSite.vue";
import ChooseMakers from "./ChooseMakers.vue";
import TicketDetails from "./TicketDetails.vue";

export default {
  data: () => ({
    steps: [],
    currentStepIndex: 0,
    chosenMakers: [],
    client: null,
    site: null,
    subComponentReady: false,
  }),
  computed: {
    currentStep() { return this.steps[this.currentStepIndex] || null; },
    ...mapState(`model/maker`, [
      `makers`,
    ]),
    ...mapState(`model/user`, [
      `isMakerUser`,
    ]),
    ...mapState(`model/client`, [
      `isMaker`,
    ]),
    ...mapState(`ui/newIntervention`, [
      `reloadKey`,
      `inboxIntervention`,
    ]),
    ...mapGetters(`ui/newIntervention`, [
      `hasInboxIntervention`,
    ]),
    title() {
      const title = `Nouvelle intervention`;
      let subtitle = ``;
      switch (this.currentStep) {
        case `chooseClient`:
          subtitle = `Choix du client`;
          break;
        case `chooseSite`:
          subtitle = `Choix du site`;
          break;
        case `chooseMakers`:
          subtitle = `Choix du prestataire`;
          break;
        case `ticketDetails`:
          // subtitle = this.makers.length > 1 ? this.maker.name : this.client.name;
          if (this.isMakerUser) {
            subtitle = this.client.name;
          } else if (this.chosenMakers.length > 1) {
            subtitle = `Mise en concurrence`;
          } else {
            subtitle = this.chosenMakers[0].name;
          }
          // subtitle = this.isMakerUser ? this.client.name : this.client.name;
          // subtitle = this.isMakerUser ? this.client.name : this.client.name;
          break;
        default:
          break;
      }

      if (this.subComponentReady) {
        return `${title} - ${subtitle}`;
      }

      return title;
    },
  },
  methods: {
    ...mapActions(`ui/newIntervention`, [
      `fetchTags`,
    ]),
    makersChoosen(chosenMakers) {
      this.chosenMakers = chosenMakers;
      this.currentStepIndex += 1;
    },
    clientChoosen(client) {
      this.client = client;
      this.currentStepIndex += 1;
    },
    siteChoosen(site) {
      this.site = site;
      this.currentStepIndex += 1;
    },
    restart() {
      this.$store.commit(`ui/newIntervention/SET_CLIENT`, {});
      this.$store.commit(`ui/newIntervention/SET_SITE`, {});
      this.$store.commit(`ui/newIntervention/SET_TITLE`, ``);
      this.$store.commit(`ui/newIntervention/SET_DESCRIPTION`, ``);
      this.$store.commit(`ui/newIntervention/SET_PRIORITY`, {});
      this.$store.commit(`ui/newIntervention/SET_DOMAIN`, {});
      this.$store.commit(`ui/newIntervention/SET_EQUIPMENTS`, []);
      this.$store.commit(`ui/newIntervention/SET_INBOX_INTERVENTION`, {});
      this.chosenMakers = [];
      this.client = null;
      this.site = null;
      this.currentStepIndex = 0;
    },
  },
  components: {
    ChooseMakers,
    ChooseClient,
    ChooseSite,
    TicketDetails,
  },
  beforeCreate() {
    this.$store.dispatch(`ui/newIntervention/changeReloadKey`);
  },
  beforeMount() {
    if (this.isMaker) {
      this.steps = [
        `chooseMakers`,
        `chooseClient`,
        `chooseSite`,
        `ticketDetails`,
      ];
    } else {
      this.steps = [
        `chooseClient`,
        `chooseSite`,
        `chooseMakers`,
        `ticketDetails`,
      ];
    }
    const isFromInbox = parseInt(this.$route.query?.fromInbox, 10) === 1;
    if (isFromInbox && this.hasInboxIntervention) {
      this.currentStepIndex = 0;
    } else {
      this.restart();
    }
    // this.currentStepIndex = this.client === null ? 0 : 1;
    this.fetchTags();
  },
  watch: {
    client(client) {
      if (client === null) { this.currentStepIndex = 0; }
    },
    currentStepIndex() {
      this.subComponentReady = false;
    },
    reloadKey() {
      this.restart();
    },
  },
};
</script>
